/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Image, Paragraph,
} from './StyledComponents';
import base64conversion from '../services/base64conversion';
import deviceInfoGenerator from '../services/deviceInfoGenerator';
import logo from '../images/logo.png';
import loader from '../images/loading.gif';
import studentActivationInfo from '../services/studentActivationInfo';
import GetSchoolName from '../View/GetSchoolName';
import { getSchoolData } from '../services/getSchoolHostname';
import { GoogleLogin  } from '@react-oauth/google';
import jwtDecode from 'jwt-decode';
import '../App.scss';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      successMsg: false,
      showErrorMsg: false,
      googleLoader: false,
      schoolName: '',
      schoolCode: '',
      schoolLogo: '',
      isRequestFailed: false,
      errorMsg: '',
    };
    this.googleResponse = this.googleResponse.bind(this);
    this.googleError = this.googleError.bind(this);
  }
  
  componentDidMount() {
    const header = base64conversion();
    const [, , schoolName2] = getSchoolData();
    const schoolNameOnError = schoolName2;
   
    fetch(`${process.env.REACT_APP_API_HEAD}/getSchoolDetailsForLoginPage`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: header,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            loading: false,
            schoolName: res.data.sch,
            schoolCode: res.data.code,
            schoolLogo: res.data.logo,
          });
        } else {
          this.setState({
            loading: false,
            schoolLogo: logo,
            schoolName: schoolNameOnError,
            isRequestFailed: true,
            errorMsg: 'Something went wrong, please try again.',
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          schoolLogo: logo,
          schoolName: schoolNameOnError,
          isRequestFailed: true,
          errorMsg: 'Something went wrong, please try again.',
        });
      });
  }
  
  googleResponse(googleRes) {
    const [os, device] = deviceInfoGenerator();
    const token  = jwtDecode(googleRes.credential);
    token.created = Math.floor(Date.now() / 1000);
    const { schoolCode } = this.state;

    const objToBeSent = {
      email: token.email,
      accessToken: googleRes.credential,
      school_code: schoolCode,
      device_os: os,
      device_type: device,
    };

    const header = base64conversion();

    fetch(`${process.env.REACT_APP_API_HEAD}/digitalIdGoogleLogin`, {
      method: 'POST',
      body: JSON.stringify(objToBeSent),
      headers: {
        'Content-Type': 'application/json',
        Authorization: header,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 200) {
          const { history } = this.props;
          const newRes = {
            first_name: res.data.fn,
            last_name: res.data.ln,
            student_id: res.data.id,
            student_no: res.data.no,
            school_name: res.data.sch,
            grade: res.data.grd,
            school_logo: res.data.logo,
            student_photo_url: res.data.photo,
            school_code: res.data.code,
            show_id: res.data.showId,
            direct_url: res.data.dUrl,
            lpass: res.data.lpass,
          };
          localStorage.setItem('studentDetails', JSON.stringify(newRes));
          if (newRes.student_photo_url === '' || newRes.student_photo_url === ' ') {
            history.push({
              pathname: '/noAccess',
              state: {
                isStudentInActive: false,
              },
            });
          } else {
            const data = {
              school_code: newRes.school_code,
              student_id: newRes.student_id,
              student_no: newRes.student_no,
            };
            studentActivationInfo(data);
            history.push('/');
          }
        } else {
          this.setState({ showErrorMsg: true, googleLoader: false, errorMsg: res.message });
        }
      })
      .catch((error) => {
        this.setState({
          showErrorMsg: true,
          successMsg: false,
          googleLoader: false,
          errorMsg: 'Something went wrong, please try again.',
        });
      });
  }
  
  googleError(error) {
     console.error(error);
  }
  render() {
    const {
      googleLoader, successMsg, showErrorMsg, loading,
      schoolName, schoolLogo, isRequestFailed, errorMsg,
    } = this.state;

    if (loading) {
      return <img src={loader} className="menu-loader" alt="Loading ..." />;
    }
    return (
      <div className="login-wrapper">
        <div className="login-box-wrapper">
          <div className="logo-wrapper">
            <Image
              src={schoolLogo}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = logo;
              }}
            />
          </div>
          <Paragraph className="login-heading" style={{ padding: '20px 0' }}>
            {schoolName && <GetSchoolName schoolName={schoolName} />}
          </Paragraph>
          {
            !isRequestFailed
              ? (
                  <GoogleLogin
                  shape='circle'
                  onSuccess={this.googleResponse}
                  />)
              : null
          }

          {successMsg ? (
            <Paragraph style={{
              color: 'white',
              fontSize: '14px',
              marginTop: '5px',
              fontWeight: 'normal',
              padding: '5px',
            }}
            >
              Login attempt done successfully.
            </Paragraph>
          ) : null}

          {showErrorMsg || isRequestFailed ? (
            <Paragraph style={{
              color: 'white',
              fontSize: '12px',
              marginTop: '5px',
              fontWeight: 'normal',
              padding: '5px',
            }}
            >
              {errorMsg}
            </Paragraph>
          ) : null}
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};
